import { useCallback, useEffect, useState } from 'react';
import { request } from '../../../../lib/utils/request';

const BASE_URL = process.env.REACT_APP_PLAT_CLIENT_CONFIG_API;

export type ClientSearchResult = {
	id: string;
	initials: string;
	name: string;
	c_code?: string;
	unlimited?: boolean;
	capabilities: string[];
	venda_end_at?: number;
	assinatura_end_at?: number;
	forum_ia_end_at?: number;
};

export type ClientsSearchResponse = {
	total: number;
	page: number;
	limit: number;
	clients: ClientSearchResult[];
	facets: Record<string, number>;
};

export type ClientsSearchParams = {
	text?: string;
	selected: string[];
	page: number;
	limit: number;
	sort: string;
	sort_dir: 'asc' | 'desc';
};

export function useClientsSearch(params: ClientsSearchParams) {
	const [data, setData] = useState<ClientsSearchResponse>();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<any>();

	const { text, selected, page, limit, sort, sort_dir } = params;
	const selected_key = selected.join(',');

	const fetch_data = useCallback(async () => {
		setLoading(true);
		setError(undefined);

		try {
			const body = {
				text: text || '',
				groups: selected.map((token) => [token]),
				page,
				limit,
				sort,
				sort_dir,
			};

			const res = await request().post<ClientsSearchResponse>(
				`${BASE_URL}/public/clients/search`,
				body
			);

			setData(res);
		} catch (e) {
			setError(e);
		} finally {
			setLoading(false);
		}
	}, [text, selected_key, page, limit, sort, sort_dir]);

	useEffect(() => {
		fetch_data();
	}, [fetch_data]);

	return { data, loading, error, refetch: fetch_data };
}
